<template>
    <div class="echart-line"  ref="echartsLineRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
export default {
    name: 'EchartLine',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['项目金额', '合同金额', '项目回款', '项目支出', '开票金额']
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '1%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['2025-04', '2025-05', '2025-06', '2025-07', '2025-08','2025-09', '2025-10', '2025-11', '2025-12', '2026-01'],
                    axisLabel: {
                        rotate: 30 // 旋转45度
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '项目金额',
                        type: 'line',
                        stack: 'Total',
                        data: [120, 132, 101, 134, 90, 230, 210,120, 132, 101, 134, 90, 230, 210]
                    },
                    {
                        name: '合同金额',
                        type: 'line',
                        stack: 'Total',
                        data: [220, 182, 191, 234, 290, 330, 310,220, 182, 191, 234, 290, 330, 310]
                    },
                    {
                        name: '项目回款',
                        type: 'line',
                        stack: 'Total',
                        data: [150, 232, 201, 154, 190, 330, 410,150, 232, 201, 154, 190, 330, 410]
                    },
                    {
                        name: '项目支出',
                        type: 'line',
                        stack: 'Total',
                        data: [320, 332, 301, 334, 390, 330, 320,320, 332, 301, 334, 390, 330, 320]
                    },
                    {
                        name: '开票金额',
                        type: 'line',
                        stack: 'Total',
                        data: [820, 932, 901, 934, 1290, 1330, 1320,820, 932, 901, 934, 1290, 1330, 1320]
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.GetLineEchart();
        })
    },
    methods:{
        GetLineEchart(){
            console.log(this.search)
            const chartDom = this.$refs.echartsLineRef;
            echarts.registerTheme('macarons', macarons);
            const myChart = echarts.init(chartDom, macarons);
            myChart.setOption(this.option);
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
